"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var lastNumberRegex = /\d+$/gi;
var getLastNumbersFromString = function getLastNumbersFromString(url) {
  var lastNumber = url.match(lastNumberRegex);
  return lastNumber === null || lastNumber === void 0 ? void 0 : lastNumber[0];
};
var _default = getLastNumbersFromString;
exports["default"] = _default;